/* LH | Partner set upsell for every product category (first: metal key chains, ClickUp 123y1w8mc8r,
 * Leon 17.10.2026; all categories through the metaobject lh_partner_upsell: Leon 20.10.2026)
 *
 * Rules and reasons (plain English):
 * - The block is rendered hidden by snippets/lh-partner-upsell.liquid and moved by this
 *   script into the Teeinblue panel: before the set switch, else directly above the Teeinblue
 *   buttons (#teeFormActions), so it sits BELOW the gift bag and the print file check. Re-placed
 *   whenever Teeinblue re-renders.
 *   Order of the blocks in the panel: gift bag, print file check, partner set, set switch, buttons (Leon, 23.10.2026). The anchor is the
 *   first of the blocks below us in DOM order. Before 23.10.2026 the gift bag and this block both
 *   insisted on the spot right above the print file check and moved each other around many times per
 *   second (flickering key chain pages).
 * - The Liquid writes a map (data-lh-partner-map): main variant id -> upsell variant id, percent,
 *   upsell price and strike price, only for variants that pass the safety rule. The block is
 *   visible only while the selected variant is in that map; price and strike price follow the variant.
 * - The switch is ON by default (Leon's decision, legal risk accepted).
 * - OFF: card at 45 % opacity. No price in the Teeinblue button (Leon: we never show one there).
 * - The card thumbnail mirrors Teeinblue's live preview, so the customer sees their own design.
 * - Teeinblue adds the main product itself (its own /cart/add call, we cannot join it).
 *   Pattern: a click on the Teeinblue button
 *   arms a pending flag; after Teeinblue's add-to-cart event (backup: a successful
 *   /cart/add response) we read /cart.js, take the newest line of this variant whose
 *   _customization_id has no partner yet, and add ONE upsell line (the upsell variant with
 *   the same SKU) with _partner_of = that _customization_id. No _customization_id -> nothing.
 * - Quantity of the upsell is always 1. Orphans and quantities are fixed in the cart by
 *   lh-partner-upsell-cart.js.
 * - Kill switch: set the entry of the category (or the upsell product) to draft.
 */
(function () {
  if (window.__lhPartnerLoaded) return;
  window.__lhPartnerLoaded = true;

  var state = { on: true, pending: false, busy: false, timer: null, mainVariant: '', upVariant: 0 };

  function root() { return document.querySelector('[data-lh-partner]'); }

  function partnerMap() {
    var r = root();
    var el = r && r.querySelector('[data-lh-partner-map]');
    try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
  }

  function currentVariantId() {
    var input = document.querySelector('form[data-type="add-to-cart-form"] .product-variant-id') ||
                document.querySelector('.product-variant-id');
    var fromUrl = new URLSearchParams(window.location.search).get('variant');
    return String((input && input.value) || fromUrl || '');
  }

  function currentEntry() {
    var m = partnerMap();
    var id = currentVariantId();
    if (m[id]) return m[id];
    // no variant known yet (first paint without ?variant): the first variant with a partner set
    var keys = Object.keys(m);
    return !id && keys.length ? m[keys[0]] : null;
  }

  function isEligible() { return !!currentEntry(); }

  function active() { return state.on && isEligible(); }

  // every Shopify money placeholder, so SEK ("{{amount_with_space_separator}} kr"), PLN, DKK etc. render too
  function formatMoney(cents) {
    var r = root();
    var fmt = (r && r.dataset.moneyFormat) || '{{amount_with_comma_separator}} €';
    function fmtNum(n, decimals, thousands, dec) {
      var parts = (Number(n) / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[0] + (parts[1] ? dec + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return fmtNum(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmtNum(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmtNum(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmtNum(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmtNum(cents, 0, ' ', ',');
        case 'amount_with_period_and_space_separator': return fmtNum(cents, 2, ' ', '.');
        default: return fmtNum(cents, 2, ',', '.');
      }
    });
  }

  function renderPrices() {
    var r = root();
    var e = currentEntry();
    if (!r || !e) return;
    var p = r.querySelector('[data-lh-partner-price]');
    var s = r.querySelector('[data-lh-partner-cmp]');
    if (p) p.textContent = formatMoney(e.price);
    if (s) s.textContent = formatMoney(e.cmp);
  }

  /* ---------- live thumbnail ---------- */
  // Leon 17.10.2026: the card shows the customer's own design, not the product photo.
  // Teeinblue builds its live preview as HTML/SVG (.tee-mockup). We clone that node, scale it into
  // the thumbnail and clone again whenever the preview changes. Until the preview exists
  // (or if it is hidden), the product photo from Liquid stays.
  var thumbTimer = null;
  function syncThumb() {
    var r = root();
    var box = r && r.querySelector('[data-lh-partner-thumb]');
    var src = document.querySelector('#tee-gallery .tee-mockup-item--loaded .tee-mockup');
    if (!box || !src || !src.offsetWidth || !src.offsetHeight) return;
    var clone = src.cloneNode(true);
    clone.querySelectorAll('[id]').forEach(function (e) { e.removeAttribute('id'); });
    var scale = Math.max(box.clientWidth / src.offsetWidth, box.clientHeight / src.offsetHeight);
    clone.style.position = 'absolute';
    clone.style.left = '0';
    clone.style.top = '0';
    clone.style.transformOrigin = '0 0';
    clone.style.transform = 'scale(' + scale + ')';
    clone.style.pointerEvents = 'none';
    var live = box.querySelector('.lh-pu__live');
    if (!live) {
      live = document.createElement('div');
      live.className = 'lh-pu__live';
      live.setAttribute('aria-hidden', 'true');
      box.appendChild(live);
    }
    live.replaceChildren(clone);
    box.classList.add('lh-pu__thumb--live');
  }
  function queueThumb() {
    clearTimeout(thumbTimer);
    thumbTimer = setTimeout(syncThumb, 250);
  }

  /* ---------- block ---------- */
  function render() {
    var r = root();
    if (!r) return;
    var tog = r.querySelector('[data-lh-partner-toggle]');
    if (tog) tog.setAttribute('aria-checked', state.on ? 'true' : 'false');
    var card = r.querySelector('[data-lh-partner-card]');
    if (card) card.classList.toggle('lh-pu-off', !state.on);
  }

  // The first block below us that already sits in the Teeinblue panel (same parent as the buttons):
  // only the set switch comes after us. The gift bag anchors to us and the print file check is
  // injected once above the buttons; when it lands between us and the buttons we simply move below it.
  function anchor() {
    var actions = document.querySelector('#teeFormActions');
    if (!actions) return null;
    var parent = actions.parentElement;
    var list = [
      document.querySelector('[data-lh-set]'),
      actions
    ].filter(function (el) { return el && el.parentElement === parent; });
    list.sort(function (a, b) { return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1; });
    return list[0] || actions;
  }

  function place() {
    var r = root();
    if (!r) return;
    var a = anchor();
    if (!a) return; // Teeinblue form not ready yet
    if (r.nextElementSibling !== a) a.insertAdjacentElement('beforebegin', r);
    r.classList.toggle('lh-pu-hidden', !isEligible());
    render();
    renderPrices();
    queueThumb();
  }

  function track(name, extra) {
    try {
      window.dataLayer = window.dataLayer || [];
      var r = root();
      var payload = { event: name, lh_upsell: 'partner_set', lh_partner_entry: (r && r.dataset.lhEntry) || '' };
      for (var k in (extra || {})) payload[k] = extra[k];
      window.dataLayer.push(payload);
    } catch (e) {}
  }

  async function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    try {
      if (drawer && typeof drawer.renderContents === 'function') {
        var res = await fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble');
        drawer.renderContents({ sections: await res.json() });
      }
    } catch (e) { console.warn('[LH Partner] drawer refresh failed', e); }
  }

  // The first signal can come before the main line is in the cart (the print file check is added first, on the same
  // click): retry every 400 ms while pending, as the lantern set does (assets/lh-set-switch.js).
  var retry = null, tries = 0;
  function retryLater() {
    clearTimeout(retry);
    if (!state.pending || ++tries > 25) return;
    retry = setTimeout(addPartner, 400);
  }
  async function addPartner() {
    if (!state.pending || state.busy) return;
    if (!root() || !state.upVariant) return;
    state.busy = true;
    try {
      var upId = state.upVariant;
      var cart = await (await fetch('/cart.js', { headers: { 'X-LH-Partner': '1' } })).json();
      var partnered = {};
      cart.items.forEach(function (i) {
        if (i.properties && i.properties._partner_of) partnered[String(i.properties._partner_of)] = true;
      });
      // cart.items is newest first
      var main = cart.items.find(function (i) {
        var cid = i.properties && i.properties._customization_id;
        return String(i.variant_id) === state.mainVariant && cid && !partnered[String(cid)];
      });
      if (!main) { retryLater(); return; } // main product not in the cart yet: try again shortly while pending
      state.pending = false;
      clearTimeout(state.timer);
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-LH-Partner': '1' },
        body: JSON.stringify({ items: [{ id: upId, quantity: 1, properties: { _partner_of: String(main.properties._customization_id) } }] })
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      track('lh_partner_added');
      setTimeout(refreshDrawer, 300);
    } catch (e) {
      console.error('[LH Partner] could not add the partner item', e);
    } finally {
      state.busy = false;
    }
  }

  // Teeinblue add to cart click: arm the pending flag (capture phase, before Teeinblue).
  // A click that fails Teeinblue's validation adds nothing, so neither signal fires and the flag runs out.
  document.addEventListener('click', function (e) {
    var atc = e.target.closest && e.target.closest('.tee-btn--atc');
    if (!atc || !active()) return;
    state.pending = true;
    tries = 0;
    state.mainVariant = currentVariantId();
    state.upVariant = Number(currentEntry().u) || 0;
    clearTimeout(state.timer);
    state.timer = setTimeout(function () { state.pending = false; }, 15000);
  }, true);

  // Teeinblue's event is "teeinblue-event-after-cart-added" (its SDK); the old name never fired, so the partner line
  // only came through the /cart/add hook below. Both names are listened to.
  ['teeinblue-event-after-cart-added', 'teeinblue-event-after-add-to-cart'].forEach(function (name) {
    document.addEventListener(name, function () { setTimeout(addPartner, 100); });
  });

  // Backup signal: a successful /cart/add that is not ours, not the ticket, not the print file check
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var h = (init && init.headers) || {};
    var get = function (k) { return typeof h.get === 'function' ? h.get(k) : h[k]; };
    var body = init && typeof init.body === 'string' ? init.body : '';
    var ignore = get('X-LH-Partner') === '1' || body.indexOf('_datacheck') !== -1;
    var p = origFetch.apply(this, arguments);
    if (!ignore && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (res) { if (res && res.ok && state.pending) setTimeout(addPartner, 250); }).catch(function () {});
    }
    return p;
  };

  // Switch and label toggle (delegated, survives re-rendering)
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-lh-partner-toggle],[data-lh-partner-label]');
    if (!t || !root() || !root().contains(t)) return;
    e.preventDefault();
    state.on = !state.on;
    track(state.on ? 'lh_partner_on' : 'lh_partner_off');
    render();
  });

  // Variant changes may switch the SKU, the upsell variant and the prices
  document.addEventListener('change', function () { setTimeout(place, 50); });

  var queued = false;
  function needsWork() {
    var r = root();
    var a = anchor();
    return !!(r && a && r.nextElementSibling !== a);
  }
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      var r = root();
      if (r && records.some(function (m) { return m.target.closest && m.target.closest('#tee-gallery') || (m.target.parentElement && m.target.parentElement.closest && m.target.parentElement.closest('#tee-gallery')); })) queueThumb();
      if (queued || !needsWork()) return;
      queued = true;
      setTimeout(function () { queued = false; place(); }, 30); // not rAF: it never fires in a tab opened in the background
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, characterData: true });
  }
  window.addEventListener('resize', queueThumb);

  function init() { place(); }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('teeinblue-event-component-injected', function () { setTimeout(init, 50); });
  window.addEventListener('load', function () { init(); setTimeout(init, 800); setTimeout(init, 2000); });
  if (document.readyState !== 'loading') init();
})();
